<template>
  <section
    class="component-a03fdab7"
    resmed-component-name="4card_icon-line_4color-graphic-title_text_link"
    v-bind:style="{
      'background-image': `url(${acf.layout['background-image']})`,
      'background-color': acf.layout['background-color'],
    }"
  >
    <div
      class="component"
      v-bind:class="[`text-color-${acf.layout['text-color']}`]"
    >
      <div class="container px-xs-sm-2">
        <div class="row justify-content-center">
          <div class="col-md-10 text-center">
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
              v-bind:align="'center'"
            ></eyebrow-icon>
            <h2 v-html="acf.headline"></h2>
          </div>
        </div>
        <div class="items text-center">
          <div class="item" v-for="item in acf.items">
            <div class="card" v-bind:class="{ 'has-cta': item.cta.href }">
              <figure
                v-bind:class="{
                  'large-icon': item.function || acf.layout['large-icon'],
                }"
              >
                <img class="img-fluid" v-bind:src="`${item.icon}`" alt="" />
              </figure>
              <p v-if="item.function">
                <strong>{{ item.function }}</strong>
              </p>
              <h4 v-bind:class="[item.color]" v-html="item.title"></h4>
              <p class="content" v-html="item.description"></p>
              <a
                v-bind:href="item.cta.href"
                v-bind:target="item.cta.target"
                class="btn cta-plain text-red icon right-arrow"
                >{{ item.cta.text }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-a03fdab7", // 4card_icon-line_4color-graphic-title_text_link
  props: ["acf"],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-a03fdab7 {
  padding: 6rem 0 5rem 0;
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
}

.component {
  &.text-color-white {
    h2 {
      &:before {
        background-color: $cc-resmed-white;
      }
    }
  }

  h2 {
    position: relative;
    margin: 0 0 3rem 0;

    @extend %eyebrow-center;
  }

  h4 {
    margin-bottom: 1rem;

    &.sa-blue {
      color: $sc2blue;
    }

    &.purple {
      color: $cc-resmed-sa-purple;
    }

    &.red {
      color: $cc-resmed-action-red;
    }

    &.blue {
      color: $cc-resmed-hero-blue;
    }

    &.black {
      color: $cc-resmed-black;
    }
  }

  p {
    color: $cc-resmed-black;
  }

  .items {
    @media (min-width: 768px) {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      margin-right: -0.5rem;
      margin-left: -0.5rem;
    }

    .item {
      display: flex;
      align-items: stretch;
      padding: 0 0.5rem;
      margin-bottom: 1rem;

      @media (max-width: 767px) {
        &:last-child {
          margin-bottom: 0;
        }
      }

      @media (min-width: 768px) {
        width: percentage(0.5);

        &:nth-child(1),
        &:nth-child(2) {
          margin-bottom: 1rem;
        }
      }

      @media (min-width: 992px) {
        width: percentage(0.25);
        margin-bottom: 0 !important;
      }

      .card {
        position: relative;
        padding: 2.5rem 1.75rem;
        background-color: $cc-resmed-white;
        border-radius: 6px;
        box-shadow: 0 0.325rem 1.25rem 0 rgba(0, 0, 0, 0.2);

        &:hover {
          background-color: $cc-resmed-bg-grey-2;
        }

        &.has-cta {
          padding: 2.5rem 1.75rem 4.5rem 1.75rem;
        }
      }

      figure {
        max-width: 3rem;
        margin: 0 auto 1rem auto;

        img {
          display: block;
        }

        &.large-icon {
          max-width: 4.5rem;
        }
      }

      .btn {
        position: absolute;
        bottom: 2.25rem;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
}
</style>